/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Notification } from 'slate-ui-components';
import {
    NotificationButtons,
    NotificationCloseButton,
    NotificationMessage,
} from './Notifications.styled';

const DELAY_BEFORE_DISPLAY = 30000;
const AUTO_DISMISS_AFTER = 10000;

const verbose = false;

export const ReserveNowNotification: React.FC<{ canShow: boolean }> = ({
    canShow,
}) => {
    const intl = useIntl();
    const [triggered, setTriggered] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const [showing, setShowing] = useState(false);
    const mainTimer = useRef<NodeJS.Timeout>(null);
    const dismissTimer = useRef<NodeJS.Timeout>(null);

    useEffect(() => {
        if (!mainTimer.current) {
            verbose && console.log('[ReserveNowNotification] Timer started');
            mainTimer.current = setTimeout(() => {
                verbose && console.log('[ReserveNowNotification] Ready');
                setTriggered(true);
            }, DELAY_BEFORE_DISPLAY);
        }

        return () => {
            if (mainTimer.current) clearTimeout(mainTimer.current);
            if (dismissTimer.current) clearTimeout(dismissTimer.current);
        };
    }, []);

    useEffect(() => {
        if (
            canShow &&
            triggered &&
            !showing &&
            !dismissTimer.current &&
            !dismissed
        ) {
            dismissTimer.current = setTimeout(() => {
                verbose &&
                    console.log('[ReserveNowNotification] Auto-dismissing');
                setDismissed(true);
            }, AUTO_DISMISS_AFTER);
            verbose && console.log('[ReserveNowNotification] Showing');
            setShowing(true);
        }
    }, [canShow, triggered, showing, dismissed]);

    return (
        <Notification
            $mode="secondary"
            $show={showing && !dismissed}
            onClick={() => {
                verbose &&
                    console.log('[ReserveNowNotification] Manually dismissed');

                setDismissed(true);
            }}>
            <NotificationMessage>
                <span>
                    <FormattedMessage
                        id="configurator.reserveFirst.tooltip"
                        /* eslint-disable-next-line formatjs/enforce-placeholders */
                        defaultMessage="Reserve now, personalize later."
                    />
                </span>
            </NotificationMessage>
            <NotificationButtons>
                <NotificationCloseButton
                    label={intl.formatMessage({
                        id: 'general.close',
                        defaultMessage: 'Close',
                    })}>
                    <Icon icon="Close" />
                </NotificationCloseButton>
            </NotificationButtons>
        </Notification>
    );
};
